import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import React from 'react';

import classes from './Success.module.scss';

export const FormsInvitationSuccess: React.FC = () => {
    return (
        <LeftColumn alignContentVertically>
            <div className={classes.root}>
                <FontAwesomeIcon icon={faCheckCircle} className={classes.icon} />

                <h1 className="h2">Successfully Submitted</h1>
                <p>Your form(s) has been successfully submitted. Thank you!</p>
            </div>
        </LeftColumn>
    );
};
